import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import LeadBannerBlockData from "../../../Models/Content/LeadBannerBlockData";
import LeadBanner from "./LeadBanner";

export default class LeadBannerBlock extends EpiComponent<LeadBannerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['lead-banner-block'];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <LeadBanner iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
